import React from "react";
import { Col } from "reactstrap";
import "../../styles/car-item.css";

const LeaseItem = (props) => {
  const { imgUrl, carName, price, carsInCategory } =
    props.item;

  return (
    <Col lg="4" md="4" sm="6" className="mb-5">
      <div className="car__item">
        <div className="car__img d-flex align-items-center">
          <img src={imgUrl} alt="" className="w-100" />
        </div>

        <div className="car__item-content mt-4">
          <h4 className="section__title text-center">{carName}</h4>
          <ol className="d-block pl-5 text-left">
            {carsInCategory.map((car, index) => (
              <li key={car.index}>
                <p>{car.carName}</p>
              </li>
            ))}
          </ol>
          <div className="text-center">
            <h6 className="rent__price mt-4 mb-4">
              Ksh {price} <span>/ Month</span>
            </h6>

            <button className="w-50 mx-auto car__item-btn car__btn-lease">
            <a
                    href="https://api.whatsapp.com/send/?phone=254750542046"
                    target="_blank"
                    rel="noopener noreferrer"
                  >Lease</a>
            </button>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default LeaseItem;
